"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportModule = void 0;
const router_1 = require("client/components/router");
const not_found_1 = require("client/modules/not-found");
const new_support_1 = require("./modules/new-support");
class SupportModule extends router_1.Router {
    constructor(props) {
        super(props);
        router_1.RouteManager.setNotFoundComponent(not_found_1.NotFoundModule);
        this.addRoute("submit", /^\/support\/?$/, new_support_1.SubmitSupport);
    }
}
exports.SupportModule = SupportModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/support/support.tsx
// module id = 4126
// module chunks = 0